<template>
  <div class="pform__shortfields" :style="{'align-items': align}">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    align: {type: String, default: ''}
  }
}
</script>

<style lang="sass">
.pform__shortfields
  display: flex
  flex-wrap: wrap
  justify-content: space-between

  >*
    width: calc(50% - 22px)
    &:nth-child(2n+1):last-child
      width: 100%
  @include for-mob
    display: block
    >*
      width: 100% !important
</style>